<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        营业执照纸张数量绑定
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="证照名称" prop="fname">
              <el-input v-model="ruleForm.fname" placeholder="所在区域+营业执照"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纸张数量" prop="fpaperqty">
              <el-input v-model="ruleForm.fpaperqty" placeholder="纸张数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="区划码" prop="fregorg">
              <el-input v-model="ruleForm.fregorg" placeholder="区划码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="终端地址" prop="faddress">
              <el-input v-model="ruleForm.faddress" placeholder="终端所在位置"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="fliaison">
              <el-input v-model="ruleForm.fliaison" placeholder="联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="fphone">
              <el-input v-model="ruleForm.fphone" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="MAC地址" prop="fmac">
              <el-input v-model="ruleForm.fmac" placeholder="MAC地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">设置完成</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      ruleForm: {
        fname: "", //终端名称
        fpaperqty: "", //纸张数量
        fregorg: "370705", //区划码
        faddress: "", //终端地址
        fliaison: "张振永", //联系人
        fphone: "13176708822", //手机号
        fmac: "", //mac地址
        fcredentialsid: "yyzzzb",
      },
      rules: {
        fname: [
          { required: true, message: '请输入终端名称', trigger: 'blur' },
        ],
        fpaperqty: [
          { required: true, message: '请输入纸张数量', trigger: 'blur' },
        ],
        fregorg: [
          { required: true, message: '请输入区划码', trigger: 'blur' },
        ],
        faddress: [
          { required: true, message: '请输入终端地址', trigger: 'blur' },
        ],
        fliaison: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        fphone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        fmac: [
          { required: true, message: '请输入MAC地址', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
  },
  mounted() {
    this.getMac()
  },
  methods: {
    getMac() {
      this.$fun.getMAC(mac => {
        this.ruleForm.fmac = mac;
        this.checkNum()
      })
    },
    // 查询纸张数量
    checkNum() {
      this.$rqt.getInfoByMacAndPrintName({
        fmac: this.ruleForm.fmac,
        fcredentialsid: this.ruleForm.fcredentialsid,
      }).then(res => {
        console.log('查询', res);
        if (res.data) {
          this.ruleForm = res.data
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$rqt.Selfservice(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000);
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getMac()
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>